import axios, { AxiosRequestConfig } from 'axios';
import { camelizeKeys } from 'xcase';

import { ErrorHandler } from '~shared/utils/ResponseHandler';

import { baseURL } from './urls';

const axiosConfig: AxiosRequestConfig = {
  baseURL,
  withCredentials: true,
};

const localAxios = axios.create(axiosConfig);

// Always configure camelizeKeys response transformation
localAxios.interceptors.response.use((response) => {
  if (response.data) {
    response.data = camelizeKeys(response.data);
  }
  return response;
});

/**
 * Socrative has an error handler that redirects on errors.
 */
export function setupSocrativeInterceptors() {
  localAxios.interceptors.response.use(
    (response) => response,
    (error) => {
      ErrorHandler(error);
      return Promise.reject(error);
    }
  );
}

export default localAxios;
